import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52caa073"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title sub-title" }, "定期収集について", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "上掲のオンライン資料を今後も継続出版する場合、国立国会図書館が定期的にアクセスをして収集することを希望しますか。（希望しない場合は出版の都度、お申出いただく必要があります。希望する場合でも、掲載ページのURLが変更になった場合は改めてお申出ください）", -1))
const _hoisted_4 = { class: "table" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createTextVNode("定期収集"),
  /*#__PURE__*/_createElementVNode("span", { class: "label required required-regularlyCollect" }, "必須")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButtonList = _resolveComponent("RadioButtonList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("table", _hoisted_4, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _hoisted_5,
          _createElementVNode("td", null, [
            _createVNode(_component_RadioButtonList, {
              modelValue: _ctx.selectedValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedValue) = $event)),
              items: _ctx.radioList,
              id: "radio-regularlyCollect",
              name: "radio-regularlyCollect"
            }, null, 8, ["modelValue", "items"])
          ])
        ])
      ])
    ])
  ]))
}